import React, { useEffect, useState } from "react";
import HeaderLeft from "./HeaderLeft";
import { Link, useNavigate } from "react-router-dom";
import DropdownRight from "./DropdownRight";
import http from "../services/http";
import GetStorage from "../services/Storage";
import polygon from "../assets/images/Polygon 56.png";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import { setID } from "../store/auth/video";
import { ToastContainer } from "react-toastify";
import { SpinnerCircular } from "spinners-react";
import download from "../assets/images/attach_file_black_2.png";

function UploadNewPracticeVideo() {
  const token = GetStorage.get("xAuthToken");
  const [error, setError] = useState("");
  const [video, setVideo] = useState({});
  const [videos, setVideos] = useState([]);
  console.log("videos in state---", videos);
  const [name, setName] = useState("");
  const [localSpin, setLocalSpin] = useState(false);
  let user = localStorage.getItem("user");
  user = JSON.parse(user);

  const handleShow = () => setShow(true);
  const handleShows = () => setShows(true);

  const [showModal, setShow] = useState(false);
  const [showModals, setShows] = useState(false);
  const [uploadSpin, setUploadSpin] = useState(false);
  const [uploadSpins, setUploadSpins] = useState(false);
  const [loading, setLoading] = useState(false);
  const [spinId, setSpinId] = useState(0);
  const [statusSpin, setStatusspin] = useState(false);
  const [names, setNames] = useState("");

  const handleClose = () => {
    setShow(false);
    setShows(false);
    setError("");
    setNames("");
  };

  const [inputText, setInputText] = useState("");
  const [url, setUrl] = useState("");
  const [value, setValues] = useState("0");
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const [id, setId] = useState(0);

  useEffect(() => {
    UploadNewVideo();
    setLoading(true);
    apibucket();
  }, []);

  const apibucket = () => {
    http
      .get(`api/analyst/bucket?token=${token}`)
      .then((res) => {
        console.log("response-------> ", res.data);
        setId(res.data.id);
        setVideos(res.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log("error==>>", error);
        setLoading(false);
      });
  };

  const DeleteVideo = (id) => {
    // setDeleteSpin(true);
    setSpinId(id);
    setStatusspin(true);

    http
      .delete(`api/analyst/bucket/${id}?token=${token}`)
      .then((res) => {
        const newData = videos.filter((item) => item.id !== id);
        setStatusspin(false);
        setSpinId(0);

        // setVideo(videos.filter((element) => element.id !== id));

        setVideos(newData);
        console.log("response", res.data);
        // setDeleteSpin(false);
      })
      .catch((error) => {
        setStatusspin(false);
        setSpinId(0);

        console.log("error==>>", error);

        // setDeleteSpin(false);
      });
  };

  const UploadNewVideo = async () => {
    http
      .get(`api/common/me?token=${token}`)
      .then((res) => {
        console.log("response===>", res.data);

        setVideo(res.data);
        setName(res.data.practice_video);
      })
      .catch((error) => {
        console.log("error ", error.response.data.errors);
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };

  const validFormats = [
    "video/mp4",             // .mp4
    "video/quicktime",       // .mov
    "video/x-msvideo",       // .avi
    "video/x-ms-wmv",        // .wmv
    "video/x-flv",           // .flv
    "video/mpeg",            // .mpeg
    "video/x-matroska",      // .mkv
    "video/3gpp",            // .3gp
    "video/3gpp2",           // .3g2
    "video/ogg",             // .ogg
    "video/webm",            // .webm
    "video/vnd.sealed.mpeg4",// Sealed MPEG4
    "video/mp2t",            // .ts
    // "application/octet-stream" // Generic binary file
  ];

  const handleUpload = (values) => {
    // if (value.type !== "video/mp4") {
    if (!validFormats.includes(value.type)) {
      setError("Invalid file.");
      return;
    } else {
      setError("");
    }
    setUploadSpin(true);
    http
      .post(`public/analyst/s3video?token=${token}`, {
        // file_type: "video/mp4",
        file_type: value.type,
        file_name: inputText,
      })
      .then((res) => {
        console.log("response", res.data);
        const { url, key } = res.data.result;
        const { inserted } = res.data;
        // setVideos([...videos, inserted]);
        console.log(url, key);
        setUploadSpin(false);

        setUrl(key);
        setLocalSpin(true);

        fetch(url, {
          body: value,
          method: "PUT",
          headers: {
            "content-type": value.type,
            Accept: "*/*",
          },
        }).then((res) => {
          setLocalSpin(false);
          apibucket();
        });
        handleClose();
        navigate("/uploadNewPracticeVideo");
      })
      .catch((error) => {
        setUploadSpin(false);
        setLocalSpin(false);

        console.log("error ", error.response.data.errors);
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };
  const handleChanges = (event) => {
    setNames(event.target.files[0].name);

    const val = event.target.files[0];
    setValues(val);
  };

  const SubmitBucket = () => {
    setUploadSpins(true);
    http
      .put(`api/analyst/submit?token=${token}`)
      .then((res) => {
        console.log("response===>", res.data);
        setUploadSpins(false);

        navigate("/backHome");
      })
      .catch((error) => {
        setUploadSpins(false);

        console.log("error ", error.response.data.errors);
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };

  return (
    <>
      <header>
        <div className="custom_container ">
          <HeaderLeft />
          <div className="user_profile">
            <DropdownRight />
          </div>
        </div>
      </header>
      <section className="otp_verification  ">
        <div className="login_inner">
          <h1 className="mb_30 main_title ">{user.data.firstname} {user.data.lastname}'s Practice Bucket</h1>
          {/* <p className="mb_40 them_para text-center mx-auto text_limit">
            Please upload your sample practice evo videos so that we can review
            them and proceed with the application
          </p> */}
          <button
            className="them_btn  btn upload_vedio Download  "
            onClick={handleShows}
          >
            Upload New Practice Video
          </button>

          <div className="table_vedio_upload  container mt_40 mb_30 h_400">
            <table className="table table-borderless table-responsive-lg">
              <thead>
                <tr>
                  <th scope="col" className="w_150 pl_25 font-weight-bold">
                    Video
                  </th>
                  <th scope="col" className="w_150 font-weight-bold">
                    Name
                  </th>
                  <th scope="col" className="w_150 font-weight-bold">
                    Date Filmed
                  </th>
                  <th scope="col" className="w_150 text-center font-weight-bold">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <div
                    style={{
                      position: "absolute",
                      marginTop: 250,
                      marginLeft: 580,
                      zIndex: 100,
                    }}
                  >
                    <SpinnerCircular size="15%" />
                  </div>
                ) : (
                  <>
                    {videos?.map((item, key) => (
                      <tr>
                        <td className="pl_25">
                          <Link to="/video" state={{ video: item.path }}>
                            <video
                              src={item.path}
                              style={{ width: 120, height: 100 }}
                            />
                            <img
                              src={polygon}
                              alt=""
                              style={{
                                position: "absolute",
                                marginTop: 40,
                                marginLeft: -70,
                                width: 20,
                                height: 20,
                              }}
                            />
                          </Link>
                        </td>
                        <td>
                          {item.path
                            .split("/")
                            [item.path.split("/").length - 1].toUpperCase()}
                        </td>
                        <td>{moment(item.created_at).format("DD MMM, YYYY")}</td>
                        <td className="text-center">
                          <button
                            type="button"
                            className="them_btn "
                            onClick={() => {
                              DeleteVideo(item.id);
                            }}
                            id={"status" + item.id}
                          >
                            {statusSpin && spinId === item.id ? (
                              <SpinnerCircular size={"11%"} />
                            ) : (
                              "Delete Video"
                            )}
                          </button>
                        </td>
                      </tr>
                    ))}
                    {localSpin ? (
                      <tr>
                        <td>
                          {" "}
                          <SpinnerCircular size="15%" />
                        </td>
                        <td>Uploading video</td>
                        <td></td>
                        <td></td>
                      </tr>
                    ) : (
                      ""
                    )}
                  </>
                )}
              </tbody>
            </table>
            {videos.length > 0 ? (
              <button
                className="them_btn   upload_vedio Download  "
                onClick={handleShow}
              >
                Submit
              </button>
            ) : (
              ""
            )}
          </div>
        </div>
      </section>

      <Modal className="starrating" show={showModals} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title as="h5">Upload Video</Modal.Title>
          <button
            onClick={handleClose}
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            {" "}
            <span aria-hidden="true">&times;</span>{" "}
          </button>
        </Modal.Header>
        <Modal.Body>
          <>
            <div className="">
              <div className="form-group  mt-3">
                <input
                  onChange={(e) => {
                    setInputText(e.target.value);
                  }}
                  className="custom_input w-95  form-control"
                  placeholder="Enter text"
                />
              </div>

              <div className="form-group vedio_modal_file icon mt-3 w-100">
                <div className="upload-btn-wrapper">
                  <button className="btn">Upload a file</button>

                  <input type="file" name="myfile" onChange={handleChanges} />

                  <div className="img_icon">
                    <a href="">
                      <img src={download} alt="" />{" "}
                    </a>
                  </div>
                </div>
                <p style={{ marginLeft: 20 }}>{names}</p>
              </div>
            </div>

            <div className="modal-footer border-top-0">
              {" "}
              <button
                type="button"
                className="them_btn_ouline "
                onClick={handleClose}
              >
                Cancel
              </button>{" "}
              <button
                type="button"
                className="them_btn "
                onClick={handleUpload}
              >
                {uploadSpin ? (
                  <SpinnerCircular className="button-spin" />
                ) : (
                  "  Upload"
                )}
              </button>
            </div>
            <h5 style={{ color: "green" }}>{message}</h5>
            <h5 style={{ color: "red" }}>{error}</h5>
          </>
        </Modal.Body>
      </Modal>

      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>Submit Bucket</Modal.Title>
          <button
            onClick={handleClose}
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            {" "}
            <span aria-hidden="true">&times;</span>{" "}
          </button>
        </Modal.Header>
        <Modal.Body>
          <>
            <p>Are you sure you whant to submit your practice bucket ? </p>
            <h6 style={{ color: "red" }}>{error}</h6>

            <div className="col-12 d-flex justify-content-start">
              <div className="btn_wraper d-flex Permissions_text align-item-center mt_40 mb_30">
                <button
                  type="button"
                  className="them_btn_ouline "
                  style={{ width: 210, borderRadius: 10, marginRight: 15 }}
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <button
                  style={{ width: 210, borderRadius: 10 }}
                  type="button"
                  className="them_btn "
                  onClick={SubmitBucket}
                >
                  {uploadSpins ? (
                    <SpinnerCircular className="button-spin" />
                  ) : (
                    "  Yes"
                  )}
                </button>
              </div>
            </div>
          </>
        </Modal.Body>
        <ToastContainer />
      </Modal>
    </>
  );
}

export default UploadNewPracticeVideo;
